const functionsToOmitFromStackTrace = ['createStackTrace', 'reportLog', 'reportMessage']

export const createStackTrace = (subtractFromStack: number = 0): string => {
  const stackLines = new Error().stack
    .split('\n')
    .filter(
      (line) =>
        line !== 'Error' && !functionsToOmitFromStackTrace.some((method) => line.startsWith(`    at ${method} `))
    )
    .slice(subtractFromStack)
  return stackLines.join('\n')
}
